import { Modal, Form, Button } from "react-bootstrap";
import { Formik } from "formik";
import MultiselectTreeCtrl from "app/views/dashboard/userDashboard/MultiselectTreeCtrl";
import {BiSave, BiX} from "react-icons/bi";
import {useLazyAddEditAccessGroupFacilitiesQuery} from "app/redux/Facility/facilityApi";
import { getDefaultSelectedFromOptions } from "app/views/dashboard/modal/DropDownModal";
import useFullPageLoader from "app/hooks/useFullPageLoader ";
import { useSelector  } from "react-redux";
import {useLazyAddEditFacilitiesAccessGroupQuery} from "app/redux/Facility/facilityApi";
import { toast } from "react-toastify";
import {useLazyAddEditAccessPointQuery} from "app/redux/AMS/amsApi";

export default function AccessPointModal(props) {
  const initialState = {
    loginUserName: localStorage.getItem("loginUserName") ?? "",
    loginUserPersonId: +localStorage.getItem("loginUserPersonId") ?? 0,
    loginUserEmail: localStorage.getItem("loginUserEmail") ?? "",
  };
  const [addEditAccessGroupFacilities] = useLazyAddEditAccessGroupFacilitiesQuery();
  const [addEditAccessPoint] = useLazyAddEditAccessPointQuery();

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { open,  eventObject, handleSubmit, closeDialog } = props;
  const AccessGroupData = eventObject.AccessGroupData;
  let selectedOptions = eventObject.itemData;
  const { selectedCompanyId } = useSelector((state) => state.company);
  const [addEditFacilitiesAccessGroup] = useLazyAddEditFacilitiesAccessGroupQuery();
  let existingAccessGroupData = getDefaultSelectedFromOptions(eventObject.AccessGroupData);
 
  const updateSelectedItems = (selectedItems) => {
    selectedOptions = selectedItems;
  }

  const handleFormSubmit  = async () => {
    const directAccessGroup = selectedOptions.filter(a => a.Type !== 'custom');
    const customAccessGroup = selectedOptions.filter(a => a.Type === 'custom');
    const existingCustomAccessGroup = existingAccessGroupData.filter(a => a.Type === 'custom');
    await UpdatetFacilityData(directAccessGroup, customAccessGroup, existingCustomAccessGroup);
  };

  const UpdatetFacilityData = async (selectedAccessGroups, customAccessGroup, existingCustomAccessGroup) => {
    showLoader();
    let obj = {};
    obj["screenType"] = "Edit";
    obj["id"] = eventObject.facilityId;
    obj["companyid"] = selectedCompanyId
    obj["name"] = initialState.loginUserName;
    obj["updatedBy"] = initialState.loginUserPersonId;
    let affectedPU = [];
    if (Array.isArray(selectedAccessGroups)){
      selectedAccessGroups.forEach((item) => {
        let obj1 = {};
        obj1["ConcatID"] = item.ConcatID;
        obj1["PropertyID"] = item.PropertyID;
        obj1["FloorID"] = item.FloorID;
        obj1["EntranceID"] = item.EntranceID;
        obj1["ConnectedType"] = item.Type;
        affectedPU.push(obj1);
      })
    }

    obj["affectedPUDetailedData"] = affectedPU;
    obj["IncludeinAffectedList"] = [];
    obj["ExcludeInAffectedList"] = [];
    obj["IsAccessGroupUpdate"] = true;
    obj["IsIncludePropertyUnitUpdate"] = false;
    obj["IsExcludePropertyUnitUpdate"] = false;

     await addEditFacilitiesAccessGroup(obj).then(async (result) => {
        hideLoader();
        toast.success("Successfully added", { autoClose: 2000 });
        await updateCustomAccessGroup(customAccessGroup,existingCustomAccessGroup);
     }, error => {
      hideLoader();
    });
  };

  const updateCustomAccessGroup = async (selectedAccessGroups,existing) => {
   
    showLoader();
    let obj = {};
    obj["companyId"] = selectedCompanyId
    obj["vendorAccessPointId"] = eventObject.facilityId;
    obj["updateBy"] = +initialState.loginUserPersonId;
    let objExisting = [];
    existing.forEach((item) => {
      let tempObj = {};
      tempObj.vendorAccessGroupId = item.vendorAccessGroupId;
      //tempObj.amsAccessGroupId = item.id;
      objExisting.push(tempObj);
    });
    let objNew = [];
    selectedAccessGroups.forEach((item) => {
      let tempObj = {};
      tempObj.vendorAccessGroupId = item.vendorAccessGroupId;
      //tempObj.amsAccessGroupId = item.id;
      objNew.push(tempObj);
    });
    obj.existingCustomAccessGroups = objExisting;
    obj.newCustomAccessGroups = objNew;
    await addEditAccessPoint(obj).then((result) => {
      hideLoader()
      if(result.isSuccess){
        handleSubmit(true);
        closeDialog();
      }
    }, error => {
      hideLoader();
    });

    hideLoader();
  }

  
  

  return (
    <Modal show={open} onHide={closeDialog} size="">
      <Formik
        enableReinitialize={true}
        initialValues={eventObject}
        onSubmit={handleFormSubmit}
        >
            
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => {
          return (
            <>
              <Modal.Header className="bg-primary text-white d-flex flex-wrap justify-content-between align-items-center">
                <h4 className="m-0 text-white">Rediger tilgangsgruppe</h4>
                <i className="i-Close-Window cursor-pointer text-18" onClick={closeDialog} />
              </Modal.Header>

              <Modal.Body>
                <Form onSubmit={handleSubmit}>
                  <Form.Group>
                      {/* <Form.Label>Tilgangspunkter</Form.Label> */}
                      {
                        //<MultiselectTreeCtrl refId={'include-propunits'} labelKey={'FacilityName'}   outSelectedItem={updateSelectedItems} options={FacilityData}></MultiselectTreeCtrl>
                        <MultiselectTreeCtrl refId={'access-groupx'} outSelectedItem={updateSelectedItems} options={AccessGroupData}></MultiselectTreeCtrl>
                      }

                  </Form.Group>
                </Form>
              </Modal.Body>
                <Modal.Footer className={''}>
                    <Button variant="secondary" onClick={closeDialog}>
                        <BiX  size={17}></BiX>
                        Lukke
                    </Button>

                    <Button   onClick={handleFormSubmit} variant="primary"  >
                        <BiSave  size={17}></BiSave>   Lagre endringer
                    </Button>
                </Modal.Footer>
            </>
          );
        }}
      </Formik>
      {loader}
    </Modal>
  );
}




